import React from 'react';
import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Palette } from '@material-ui/core/styles/createPalette';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import WarningIcon from '@material-ui/icons/Warning';
import { normalizeText } from '../../../../shared/utils';
import { StatusText } from './styles';
import { IDENTITY_STATUS, IdentityDisplayStatus } from './types';

type IdentityStatusProps = {
  status: IdentityDisplayStatus;
};

function StatusIcon({
  status,
  palette,
}: {
  status: IdentityDisplayStatus;
  palette: Palette;
}) {
  switch (status) {
    case IDENTITY_STATUS.ACTIVE:
      return <CheckCircleIcon style={{ color: palette.success.main }} />;
    case IDENTITY_STATUS.SUSPENDED:
      return <WarningIcon style={{ color: palette.error.main }} />;
    case IDENTITY_STATUS.DEACTIVATED:
      return <RemoveCircleIcon style={{ color: palette.text.secondary }} />;
    default: {
      return null;
    }
  }
}

export function IdentityStatus({ status }: IdentityStatusProps) {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gridColumnGap={4}>
      <StatusIcon status={status} palette={theme.palette} />
      <StatusText variant="body2">{normalizeText(status)}</StatusText>
    </Box>
  );
}
